import { SyntaxError } from "./errors.js";
import { time } from "./variables/time.js";

const processUnsupportedVariable = async () => await new SyntaxError().handleError();
const unsupportedVariable = processUnsupportedVariable;

export const variables = {
    TI:    time(),
    TIME:  time(),
    TI$:   unsupportedVariable,
    TIME$: unsupportedVariable
};

export const isSupportedVariable = (variableName) => variables.hasOwnProperty(variableName) && variables[variableName] !== unsupportedVariable;